import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { CssSelectors } from '../../../../styles/styles';

const {
	spacing,
	colors,
	common: { border, borderRadius },
	typography: { fontSizes },
} = THEME;

export const styleSheet = StyleSheet.create({
	drawerContainer: {
		backgroundColor: colors.background.light,
		height: '100%',
		padding: spacing.lg,
		width: '100%',
		gap: spacing.md,
	},
	heading: {
		color: colors.text.dark,
		fontSize: fontSizes.lg,
		margin: spacing.none,
	},
	divider: {
		borderBottom: border,
	},
	gap: {
		gap: spacing.sm,
	},
	textBase: {
		margin: spacing.none,
	},
	textSm: {
		fontSize: fontSizes.sm,
		color: colors.text.main,
	},
	checkboxRow: {
		alignItems: 'center',
		display: 'flex',
		gap: spacing.sm,
	},
	tagListBuilderContainer: {
		margin: spacing.none,
		background: colors.background.light,
		borderRadius,
		width: 'auto',
		...CssSelectors.allDescendants(
			{
				background: colors.background.light,
			},
			'.autocomplete-search-field-input'
		),
	},
});
